// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "../../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as WorkSpaceContext from "../../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as TertiaryButton$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/TertiaryButton.bs.js";
import * as WalletTransactionStatus from "../../../../app/wallet/entity/WalletTransactionStatus.bs.js";
import * as OptionTypeUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.bs.js";
import * as TableRowHeaderComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableRowHeaderComponent.bs.js";

function getTransactionDetails(transaction, workspaceDispatch) {
  var orderId = transaction.orderId;
  var subtitleSection = orderId !== undefined ? React.createElement(TertiaryButton$Catalyst.make, {
          onSelectCB: (function (param) {
              return Curry._2(workspaceDispatch.addTab, {
                          TAG: /* OrderDetails */10,
                          _0: orderId,
                          _1: undefined
                        }, false);
            }),
          children: orderId
        }) : React.createElement("p", undefined, transaction.subtitle);
  var match = transaction.status;
  var pendingTxnUuidSection = match !== 1 ? null : React.createElement("p", undefined, React.createElement("label", undefined, "transaction id:"), transaction.uuid);
  return React.createElement(React.Fragment, undefined, React.createElement("p", undefined, $$String.capitalize_ascii(transaction.title)), subtitleSection, React.createElement("p", undefined, OptionTypeUtils$Catalyst.getEmptyStringFrmOptionalType(transaction.statusReason)), pendingTxnUuidSection);
}

function otherTxnDetailsAccessor(transaction) {
  return {
          TAG: /* Custom */5,
          _0: (function (param) {
              var comment = transaction.adminComment;
              var email = transaction.adminEmail;
              return React.createElement(React.Fragment, undefined, React.createElement("p", {
                              className: "cell-text"
                            }, comment !== undefined ? React.createElement("p", undefined, React.createElement("label", undefined, "Admin Comment: "), comment) : ""), email !== undefined ? React.createElement("p", undefined, React.createElement("label", undefined, "Admin Email: "), email) : null);
            })
        };
}

function getTableColumnsSchema(workspaceDispatch) {
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Status"
            },
            accessor: (function (transaction) {
                return {
                        TAG: /* Custom */5,
                        _0: (function (param) {
                            var dateString = Timestamp$Catalyst.toString(transaction.ts, "DD/MM/YYYY");
                            var timeString = Timestamp$Catalyst.toString(transaction.ts, "HH:mm:ss");
                            var txnStatus = $$String.lowercase_ascii(WalletTransactionStatus.toString(transaction.status));
                            return React.createElement(React.Fragment, undefined, React.createElement("p", undefined, dateString + ",", React.createElement("span", {
                                                className: "secondary-text"
                                              }, timeString)), React.createElement("p", {
                                            className: "secondary-text txn-status " + txnStatus
                                          }, $$String.capitalize_ascii(txnStatus)));
                          })
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Transaction Details"
              },
              accessor: (function (transaction) {
                  return {
                          TAG: /* Custom */5,
                          _0: (function (param) {
                              return getTransactionDetails(transaction, workspaceDispatch);
                            })
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Amount"
                },
                accessor: (function (transaction) {
                    var txnAmount = transaction.amount.toString();
                    return {
                            TAG: /* Text */0,
                            _0: CountryConfig.getSymbol(country) + txnAmount
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Remarks"
                  },
                  accessor: otherTxnDetailsAccessor
                },
                tl: /* [] */0
              }
            }
          }
        };
}

function displayDate(x) {
  return Timestamp$Catalyst.toString(x.ts, "DD MMMM, YY");
}

function getFormattedRows(_transactions, _rowsData, _subRows, _pre) {
  while(true) {
    var pre = _pre;
    var subRows = _subRows;
    var rowsData = _rowsData;
    var transactions = _transactions;
    if (pre !== undefined) {
      if (!transactions) {
        return List.append(rowsData, {
                    hd: {
                      label: {
                        TAG: /* Text */0,
                        _0: Timestamp$Catalyst.toString(pre.ts, "DD MMMM, YY")
                      },
                      rows: subRows
                    },
                    tl: /* [] */0
                  });
      }
      var tail = transactions.tl;
      var head = transactions.hd;
      if (Timestamp$Catalyst.toString(pre.ts, "DD MMMM, YY") === Timestamp$Catalyst.toString(head.ts, "DD MMMM, YY")) {
        _pre = head;
        _subRows = List.append(subRows, {
              hd: head,
              tl: /* [] */0
            });
        _transactions = tail;
        continue ;
      }
      _pre = head;
      _subRows = {
        hd: head,
        tl: /* [] */0
      };
      _rowsData = List.append(rowsData, {
            hd: {
              label: {
                TAG: /* Text */0,
                _0: Timestamp$Catalyst.toString(pre.ts, "DD MMMM, YY")
              },
              rows: subRows
            },
            tl: /* [] */0
          });
      _transactions = tail;
      continue ;
    }
    if (!transactions) {
      return /* [] */0;
    }
    var head$1 = transactions.hd;
    _pre = head$1;
    _subRows = {
      hd: head$1,
      tl: /* [] */0
    };
    _transactions = transactions.tl;
    continue ;
  };
}

function WalletTransactionListView(Props) {
  var transactions = Props.transactions;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  return React.createElement(TableRowHeaderComponent$Catalyst.make, {
              columns: getTableColumnsSchema(workspaceDispatch),
              rowData: getFormattedRows(transactions, /* [] */0, /* [] */0, undefined),
              className: "customTable"
            });
}

var make = WalletTransactionListView;

export {
  getTransactionDetails ,
  otherTxnDetailsAccessor ,
  getTableColumnsSchema ,
  displayDate ,
  getFormattedRows ,
  make ,
  
}
/* react Not a pure module */
